import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Call = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M7.87 9.293c.721 1.43 1.68 2.77 2.873 3.964a15.5 15.5 0 0 0 3.964 2.874l1.46-1.46a1 1 0 0 1 1.219-.151l2.511 1.498a1 1 0 0 1 .195 1.566l-2.6 2.6c-.506.505-1.244.71-1.921.485a19.2 19.2 0 0 1-3.713-1.69 19.4 19.4 0 0 1-3.85-2.987 19.4 19.4 0 0 1-2.988-3.85 19.2 19.2 0 0 1-1.69-3.713c-.224-.677-.02-1.415.486-1.92l2.6-2.601a1 1 0 0 1 1.566.195L9.48 6.614a1 1 0 0 1-.151 1.22z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.886 3.378a1.75 1.75 0 0 1 2.74.34l1.499 2.512a1.75 1.75 0 0 1-.266 2.134L8.791 9.432a14.7 14.7 0 0 0 2.483 3.294 14.7 14.7 0 0 0 3.294 2.483l1.068-1.068a1.75 1.75 0 0 1 2.134-.266l2.512 1.499a1.75 1.75 0 0 1 .34 2.74l-2.6 2.6c-.688.688-1.717.99-2.688.667a20 20 0 0 1-3.857-1.756 20 20 0 0 1-4-3.103 20 20 0 0 1-3.103-3.999A20 20 0 0 1 2.62 8.666c-.322-.97-.02-2 .666-2.688z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
